import React from 'react';
import PropTypes from 'prop-types';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { connect } from 'react-redux';

import { getAppUrl } from '../../urls';

const URL_BASE = getAppUrl();

const getUrl = canonicalUrl => `${URL_BASE}${canonicalUrl}`;

const Seo = ({ breadcrumbs, canonicalUrl, description, title }) => {
  const pageUrl =
    typeof canonicalUrl !== 'undefined' ? getUrl(canonicalUrl) : '';
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={pageUrl}
        openGraph={{
          description,
          title,
          url: pageUrl,
        }}
      />
      {breadcrumbs && <BreadcrumbJsonLd itemListElements={breadcrumbs} />}
    </>
  );
};

Seo.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      item: PropTypes.string.isRequired,
    }),
  ),
  canonicalUrl: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
};

export default React.memo(Seo);
